import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'

import pusher from '@/pusher'

import auth from './modules/auth'
import router from '../router/index'
const showFuture = process.env.VUE_APP_SHOW_FUTURE == 'true'

Vue.use(Vuex)

const isDemoMode = process.env.VUE_APP_MODE === 'demo'

function updateState (context, orgId) {
  if (!orgId) {
    return
  }
  const channel = pusher.subscribe(orgId)
  channel.bind('update-state', (data) => {
    if (data) {
      context.dispatch('loadCurrentOrganization', context)
    }
  })
}

function startPollMonitoring ({ commit, state }, orgId) {
  if (!orgId) {
    return
  }

  const channel = pusher.subscribe(orgId)
  console.log(orgId, 'id')
  channel.bind('new-message', (data) => {
    if (!data) {
      return
    }

    const pollObj = data.poll_obj
    const collectorObj = data.collector_obj
    const apiKey = data.api_key
    if (!pollObj || !pollObj.id) {
      return
    }

    const ts = (new Date()).getTime()

    const apiKeyObj = state.apiKeyStore.api_keys.find(item => item.key === apiKey)
    if (apiKeyObj) {
      apiKeyObj.last_used = moment(ts).format('YYYY-MM-DD HH:mm:ss')
      commit('updateApi_keyData', apiKeyObj)
    }

    const collector = collectorObj || state.collectorStore.collectors.find(item => item.entity_id === pollObj.id && item.collector_type != 'management') || state.processingClustersStore.processingClusters.find(item => item.entity_id === pollObj.id)

    if (collector) {
      collector.collector_version = pollObj.version
      collector.environment_support = pollObj.environment_support
      collector.intervals = pollObj.polling_interval
      collector.public_ip = pollObj.public_ip
      collector.ts = ts
      // collector.status = 'Active'
      collector.drives = pollObj.drives
      if (collector.collector_type === 'management') {
        collector.incoming_count = pollObj.incoming_count
        collector.content_count = pollObj.content_count
        collector.cluster_status = pollObj.cluster_status
      }
      if (collector.collector_type == 'management') {
        commit('updateProcessingClusterData', collector)
      } else {
        commit('updateCollectorData', collector)
      }
    }
  })

  channel.bind('collector-updated', (collector) => {
    console.log(collector, 'collector-updated')
    const collectorOld = state.collectorStore.collectors.find(item => item.entity_id === collector.entity_id)
    if (collectorOld) {
      collector.intervals = collectorOld.intervals
      collector.ts = collectorOld.ts
      collector.status = collectorOld.status
    }
    // commit('updateCollectorData', collector)
    if (collector.collector_type == 'management') {
      commit('updateProcessingClusterData', collector)
    } else {
      commit('updateCollectorData', collector)
    }
  })

  channel.bind('download_status', (data) => {
    if (!data || !data.api_key) return
    const apiKeyObj = state.apiKeyStore.api_keys.find(item => item.key === data.api_key)
    if (apiKeyObj) {
      if (data.download_available) apiKeyObj.download_available = data.download_available
      if (data.mgmt_download_available) apiKeyObj.mgmt_download_available = data.mgmt_download_available
      if (data.docker_download_available) apiKeyObj.docker_download_available = data.docker_download_available
      commit('updateApi_keyData', apiKeyObj)
    }
  })

  channel.bind('scan-stats', (data) => {
    if (!data) return
    if (data.last_updated) {
      data.last_updated = moment.utc(data.last_updated, 'YYYY-MM-DD HH:mm:ss').local().toISOString()
    }
    commit('addScanStats', { ...data })
  })

  startStatusMonitoring({ commit, state })
}

function scanMonitoring (context, orgId) {
  if (!orgId) {
    return
  }
  const channel = pusher.subscribe(orgId)
  channel.bind('scan-current-status', (data) => {
    if (!data) {
      return
    }
    context.commit('scansData', data)
    const status = data.current_status.toLowerCase()
    setTimeout(() => {
      status.includes('complete') &&
        context.dispatch('discoveryServices/getScansList', { organization_id: orgId }) &&
        showFuture && context.dispatch('discoveryServices/timeSeries', { organization_id: orgId })
    }, 3000)
  })

  channel.bind('new-discovery-scan', (data) => {
    if (!data) {
      return
    }
    context.dispatch('discoveryServices/getScansList', { organization_id: orgId }) &&
        showFuture && context.dispatch('discoveryServices/timeSeries', { organization_id: orgId })
  })
}

function stopPollMonitoring (orgId) {
  stopStatusMonitoring()

  if (!orgId) {
    return
  }

  pusher.unsubscribe(orgId)
}

function calculateCollectorStatus (interval, ts) {
  const now = (new Date()).getTime()

  let status = 'Unknown'
  const timeDiff = (now - parseInt(ts))
  if (timeDiff <= 2 * parseInt(interval) * 1000) {
    status = 'Active'
  } else if (timeDiff > 2 * parseInt(interval) * 1000 && timeDiff <= 3 * parseInt(interval) * 1000) {
    status = 'Warning'
  } else {
    status = 'Offline'
  }
  return status
}

let statusMonitor = null
function startStatusMonitoring (context) {
  setInterval(function () {
    monitorStatus(context)
  }, 500)
}

function monitorStatus ({ commit, state }) {
  for (const collector of state.collectorStore.collectors) {
    if (typeof collector.intervals === 'undefined' || typeof collector.ts === 'undefined') {
      continue
    }

    const status = calculateCollectorStatus(collector.intervals, collector.ts)
    if (status !== collector.status) {
      console.debug('Status changed from [' + collector.status + '] to [' + status + '] for ' + collector.name)
      collector.status = status
      // commit('updateCollectorData', collector)
      if (collector.collector_type == 'management') {
        commit('updateProcessingClusterData', collector)
      } else {
        commit('updateCollectorData', collector)
      }
    }
  }

  for (const processingClusters of state.processingClustersStore.processingClusters) {
    if (typeof processingClusters.intervals === 'undefined' || typeof processingClusters.ts === 'undefined') {
      continue
    }

    const status = calculateCollectorStatus(processingClusters.intervals, processingClusters.ts)
    if (status !== processingClusters.status) {
      console.debug('Status changed from [' + processingClusters.status + '] to [' + status + '] for ' + processingClusters.name)
      processingClusters.status = status
      // commit('updateCollectorData', collector)
      if (processingClusters.collector_type == 'management') {
        commit('updateProcessingClusterData', processingClusters)
      } else {
        commit('updateCollectorData', processingClusters)
      }
    }
  }
}

function stopStatusMonitoring () {
  if (statusMonitor) {
    clearInterval(statusMonitor)
    statusMonitor = null
  }
}

export const store = new Vuex.Store({
  state: {
    currentOrganization: {}
  },
  getters: {
    currentOrganization: state => {
      return state.currentOrganization
    }
  },
  actions: {
    loadCurrentOrganization (context) {
      const organizations = context.state.organizationStore.organizations

      let organization = {}
      const organizationString = localStorage.getItem('reveles-currentOrganization')
      if (organizationString) {
        try {
          organization = JSON.parse(organizationString)
        } catch (ex) {
          console.error(ex)
        }
      }

      if (organization.entity_id) {
        organization = organizations.find(org => org.entity_id === organization.entity_id)
        if (!organization) {
          organization = {}
        }
      }

      if (!organization.entity_id/* && organizations.length === 1 */) {
        organization = organizations[0]
      }

      context.dispatch('changeCurrentOrganization', organization)
    },

    async changeCurrentOrganization (context, organization) {
      const license = await context.dispatch('fetchOrganizationLicense', organization.entity_id)

      stopPollMonitoring(context.state.currentOrganization.entity_id)
      localStorage.setItem('reveles-currentOrganization', JSON.stringify(organization))
      context.commit('setCurrentOrganization', organization)
      context.dispatch('resetData')
      context.dispatch('getBillingInfo', organization.entity_id)
      if (organization.entity_id) {
        const collector = await context.dispatch('loadCollectors', organization.entity_id)

        if (license.data && license.data.description === 'rra_level1') {
          if (collector.data && collector.data.length) router.push('/discovery')
          else router.push('/utilities')
        }

        context.dispatch('load_scans', organization.entity_id)
        context.dispatch('loadApi_keys', organization.entity_id)
        context.dispatch('loadProcessingClusters', organization)
        context.dispatch('loadCostPerRecordStudies', organization.entity_id)
        context.dispatch('loadCyberSecurityAssessments', organization.entity_id)
        context.dispatch('schedulingServices/getScans', organization.entity_id)
        context.dispatch('loadExports', { organization_id: organization.entity_id })
        context.dispatch('discoveryServices/getScansList', { organization_id: organization.entity_id }).then((data) => {
          const localList = data
          localList.sort((a, b) => {
            return moment(b.scan_start_time, 'YYYY-MM-DD hh-mm A').valueOf() - moment(a.scan_start_time, 'YYYY-MM-DD hh-mm A').valueOf()
          })
          localList.length && context.dispatch('discoveryServices/getAnalysis', { organization_id: organization.entity_id, discovery_id: localList[0].entity_id, drives: [] })
        })
        context.dispatch('partnerServices/getAllPortals', organization.entity_id)
        if (showFuture) {
          const payload = { organization_id: organization.entity_id }
          context.dispatch('discoveryServices/timeSeries', payload)
        }

        if (!isDemoMode) {
          await context.dispatch('dashboardServices/loadEnterpriseRiskData', { organizationId: organization.entity_id })
          context.dispatch('catalogServices/loadCatalogData', {
            dst: 'both',
            organization_id: organization.entity_id,
            date: router.currentRoute.query.date
          })
          context.dispatch('dashboardServices/loadOverviewRiskData', { organizationId: organization.entity_id })
          context.dispatch('dashboardServices/loadZoomTreeMapData', { organizationId: organization.entity_id })
        }
      }

      if (organization.entity_id) {
        startPollMonitoring(context, organization.entity_id)
        scanMonitoring(context, organization.entity_id)
        updateState(context, organization.entity_id)
      }
    },

    resetData (context) {
      context.commit('discoveryServices/RESET_DISCOVERY_DATA')
      context.commit('dashboardServices/RESET_ENTERPRISE_RISK')
      context.commit('resetCollectors')
      context.commit('resetFiltered_api_keys')
      context.commit('catalogServices/RESET_CATALOG_DATA')
      context.commit('catalogServices/RESET_CONTAINER_DATA')
      context.commit('resetScans')
      context.commit('schedulingServices/RESET_SCANS')
    },

    stopPollMonitoring (context) {
      stopPollMonitoring(context.state.currentOrganization.entity_id)
    },
    addUser (context, payload) {
      context.commit('addUser', payload)
    },
    deleteUser (context, id) {
      context.commit('deleteUser', id)
    }
  },

  mutations: {
    setCurrentOrganization (state, organization) {
      state.currentOrganization = organization
    },
    addUser (state, payload) {
      let flag = false
      state.currentOrganization.users = state.currentOrganization.users.map(user => {
        if (user.user_id == payload.user_id) {
          user = payload
          flag = true
        }
        return user
      })
      if (!flag) {
        state.currentOrganization.users.push(payload)
      }
    },
    deleteUser (state, id) {
      state.currentOrganization.users = state.currentOrganization.users.filter(u => u.user_id != id)
    }
  },

  modules: {
    auth
  }
})

const req = require.context('../services', true, /\.(js)$/i)
const allServices = req.keys().map(key => {
  const name = key.match(/\w+/)[0]
  return Vue.component(name, req(key))
})

for (let i = 0; i < allServices.length; i++) {
  store.registerModule(`${allServices[i].default.name}`, allServices[i].default)
}
